var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "594DF98E-C10C-415E-BE5E-04FCB09D7EC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/edit",
    fill: "#9C9C9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39770599,2.67552182 L12.4720491,5.94198102 L4.69003773,14.2103681 L1.61743766,10.9439089 L9.39770599,2.67552182 Z M14.8048809,1.88772676 L13.4338422,0.430998102 C12.903983,-0.13197723 12.0436013,-0.13197723 11.511942,0.430998102 L10.198624,1.82639848 L13.2729671,5.09288805 L14.8048809,3.4652296 C15.2158411,3.02855408 15.2158411,2.32437192 14.8048809,1.88772676 Z M0.00857238531,15.5351803 C-0.0473767162,15.8027173 0.179962942,16.042444 0.431791048,15.9773814 L3.85763054,15.0948311 L0.785030472,11.8283719 L0.00857238531,15.5351803 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c5cb166996c6f3280f1aabb8ea9276dd.svg";
export { ForwardRef as ReactComponent };